import { onError } from "@apollo/client/link/error";
import dayjs from "dayjs";

import { trackNonUIEvent } from "../../utils/telemetry/trackNonUIEvent";
import { RequestResult } from "../../utils/telemetry/constants";
import { AppLaunchError } from "../../utils/constants/appLaunchError";
import { paths } from "../../utils/routes/paths";
import { ApolloErrorExtension, ErrorExtensionData } from "../apollo.types";

export const getErrorLink = () =>
  onError(({ operation, graphQLErrors, networkError }) => {
    const { operationName } = operation;
    const context = operation.getContext();
    const { eventStartTime } = context;
    const endTime = dayjs();

    const durationInMs = eventStartTime ? endTime.diff(eventStartTime) : 0;
    const requestHeaders = context?.headers;
    const correlationId = requestHeaders?.["x-ms-correlationid"];
    const responseObject = context?.response;
    const resultCode = responseObject?.statusCode;
    const contentLength = responseObject?.headers?.get("content-length");
    const url = responseObject?.url ?? "";

    if (graphQLErrors) {
      for (const graphqlError of graphQLErrors) {
        const errorType: string | undefined = (
          graphqlError.extensions as ApolloErrorExtension
        )?.data?.errorType;
        const errorSubType: string | undefined = (
          graphqlError.extensions as ApolloErrorExtension
        )?.data?.errorSubType;

        trackNonUIEvent({
          durationInMs,
          correlationId,
          operationName,
          error: graphqlError,
          requestResult: RequestResult.Error,
          eventStartTime,
          resultCode,
          contentLength,
          url,
          errorType,
          errorSubType,
        });
      }
    }

    if (networkError) {
      trackNonUIEvent({
        durationInMs,
        correlationId,
        operationName,
        error: networkError,
        requestResult: RequestResult.NetworkError,
        eventStartTime,
        resultCode,
        contentLength,
        url,
      });
    }

    // Redirect to global error page if error is found.
    graphQLErrors?.find(({ extensions }) => handleError(extensions?.data));
  });

const handleError: (data?: ErrorExtensionData) => void = (data) => {
  if (
    data?.errorSubType?.toLowerCase() === AppLaunchError.AuthStateInvalid ||
    data?.errorSubType?.toLowerCase() === AppLaunchError.UnAuthorized ||
    data?.errorSubType?.toLowerCase() === AppLaunchError.UnAuthenticated ||
    data?.errorSubType?.toLowerCase() === AppLaunchError.AccessTokenInvalid ||
    data?.errorSubType?.toLowerCase() === AppLaunchError.AadStateInvalid ||
    data?.errorSubType?.toLowerCase() ===
      AppLaunchError.CannotStampEhrExtension ||
    data?.errorSubType?.toLowerCase() ===
      AppLaunchError.CannotAcquireAccessToken ||
    data?.errorSubType?.toLowerCase() === AppLaunchError.SessionExpired ||
    data?.errorSubType?.toLowerCase() === AppLaunchError.TenantConfigNotFound ||
    data?.errorSubType?.toLowerCase() ===
      AppLaunchError.NoTenantConfigsConfigured ||
    data?.errorSubType?.toLowerCase() ===
      AppLaunchError.EncounterHasMultipleAppointmentReferences ||
    data?.errorSubType?.toLowerCase() ===
      AppLaunchError.EncounterHasNoAppointmentReference ||
    data?.errorSubType?.toLowerCase() === AppLaunchError.SubjectNotPatient ||
    data?.errorSubType?.toLowerCase() === AppLaunchError.TenantSuspended ||
    data?.errorSubType?.toLowerCase() === AppLaunchError.Licensenotfound ||
    data?.errorSubType?.toLowerCase() === AppLaunchError.UserConfigNotFound ||
    data?.errorSubType?.toLowerCase() === AppLaunchError.CannotCreateMeeting ||
    data?.errorSubType?.toLowerCase() === AppLaunchError.NotVirtualVisit ||
    data?.errorSubType?.toLowerCase() === AppLaunchError.PatientInactive ||
    data?.errorSubType?.toLowerCase() === AppLaunchError.AppointmentNotFound
  ) {
    window.location.replace(
      `${paths.error}?type=${data.errorSubType?.toLowerCase()}`
    );
  }
};
